import {useQuery} from '@tanstack/react-query';
import {QUERY_KEYS} from 'infra/libs/react-query/queryKeys';
import {GetSaoLucasBillsParams} from 'domain/usecases';
import {getSaoLucasBills} from '../../services/getSaoLucasBills';

type QueryParams = Omit<GetSaoLucasBillsParams, 'signal'>;

export const useGetSaoLucasBillsQuery = (enabled: boolean, params: QueryParams) =>
	useQuery({
		queryKey: [QUERY_KEYS.SAO_LUCAS_BILLS, params],
		queryFn: async ({signal}) => getSaoLucasBills({...params, signal}),
		retry: 2,
		enabled,
	});
